import {
  isImageInsideObstacle,
  isPositionFree,
  canPlaceImage,
} from "../canvasFunction";
import { updateRoofDetails } from "../../../../Features/quantityInfo";
import { panelInformation } from "../../../DataFiles/panelInformation";
import { generationLosses } from "../../Functions/generationCalculate";
import { getPixelsPerMeter } from "./smithStructure";

export const customizedPlacement = ({
  roofInfo,
  structureItem,
  dispatch,
  abstacles,
  limitCapacity,
  quantityInfo,
  roofDetail,
}) => {
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];

  sessionStorage.setItem("structureItem", JSON.stringify(structureItem));

  let pixelMultiple = getPixelsPerMeter(roofInfo);

  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? structureItem.gap * 1000
      : roofDetail.rowDistance;
  const panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  const panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );
  const imgSrc = structureItem.structureImgSrc;
  const imgDimension = {
    height: (2 * panel.height + 0.025) * pixelMultiple,
    width: (panel.width + 0.025) * pixelMultiple,
    gap: (rowDistance / 1000) * pixelMultiple,
  };

  const newImages = [];
  const polygonCoordinates = roofPolygons[quantityInfo.roofNo].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x + 0,
    point.y + 0,
  ]);
  const minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));

  const angleDegrees = 0;
  let x = minX + pixelMultiple * 0.355;
  let y = minY + pixelMultiple * 0.305;
  let col = 0;
  let row = 0;
  let isFirstRowPlaced = false;
  let updateCondition = true;
  while (y <= maxY) {
    while (x <= maxX - pixelMultiple * 0.1) {
      if (limitCapacity !== 0 && newImages.length > limitCapacity) {
        updateCondition = false;
      }
      if (
        updateCondition &&
        col === 0 &&
        canPlaceImage(
          x,
          y,
          imgDimension.width * 3,
          imgDimension.height,
          polygonCoordinates,
          angleDegrees
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.width * 3,
          imgDimension.height,
          abstacles
        )
      ) {
        for (let i = 0; i < 3; i++) {
          col++;
          if (col === 1) {
            isFirstRowPlaced = true;
            row++;
            if (row === 1) {
              y += pixelMultiple * 0.305;
            }
          }
          const imageId =
            Number(Math.floor(Math.random() * 499)) *
            Number(Math.floor(Math.random() * 499));
          const newImage = {
            id: imageId,
            src: imgSrc,
            x: x,
            y: y,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: 0,
          };
          newImages.push(newImage);
          x += imgDimension.width;
        }
      } else if (
        updateCondition &&
        col > 2 &&
        canPlaceImage(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          polygonCoordinates,
          angleDegrees
        ) &&
        isPositionFree(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          newImages
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          abstacles
        )
      ) {
        col++;
        const newImage = {
          id: newImages.length,
          src: imgSrc,
          x: x,
          y: y,
          width: imgDimension.width,
          height: imgDimension.height,
          type: structureItem.name,
          gap: imgDimension.gap,
          angleDegree: 0,
        };
        newImages.push(newImage);
        x += imgDimension.width;
      } else {
        x += 1;
        col = 0;
      }
    }
    if (row === 0 && !isFirstRowPlaced) {
      y += 1;
    } else {
      y += imgDimension.height + imgDimension.gap;
    }
    col = 0;
    x = minX + pixelMultiple * 0.305;
  }

  calculateCustomizedStructure({
    newImages,
    structureItem,
    dispatch,
    quantityInfo,
    roofDetail,
    roofInfo,
  });
};

export const calculateCustomizedStructure = ({
  newImages,
  structureItem,
  dispatch,
  quantityInfo,
  roofDetail,
  roofInfo,
}) => {
  const customDetail = {
    beam: 0,
    polls: 0,
    rail: 0,
    endClamp: 0,
    midClamp: 0,
  };
  let col = 0;
  const lastImage = newImages[newImages.length - 1];
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  for (let i = 0; i < newImages.length; i++) {
    const element = newImages[i];
    if (element.id === newImages[0].id) {
      col++;
      customDetail.endClamp += 4;
    } else if (
      (element.x - newImages[i - 1].x).toFixed(2) === element.width.toFixed(2)
    ) {
      col++;
      if (element.id === lastImage.id) {
        const block = Number((col / 3).toFixed(0));
        customDetail.beam += block + 1;
        customDetail.polls += 3 * (block + 1);
        customDetail.rail += 4 * (col * panel.width * 3.28084 + 100 / 304.8);
        customDetail.endClamp += 4;
        customDetail.midClamp += (col - 1) * 4;
      }
    } else if (
      (element.x - newImages[i - 1].x).toFixed(2) !== element.width.toFixed(2)
    ) {
      const block = Number((col / 3).toFixed(0));
      customDetail.beam += block + 1;
      customDetail.polls += 3 * (block + 1);
      customDetail.rail += 4 * (col * panel.width * 3.28084 + 100 / 304.8);
      customDetail.endClamp += 8;
      customDetail.midClamp += (col - 1) * 4;
      col = 1;
    }
  }

  const totalKilowatt = Number(
    (newImages.length * 2 * (panel.pMax / 1000)).toFixed(1)
  );

  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? structureItem.gap * 1000
      : roofDetail.rowDistance;

  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: totalKilowatt,
    customCapacity: totalKilowatt,
    totalStructure: "--",
    pvModule: newImages.length * 2,
    endClamp: customDetail.endClamp,
    midClamp: customDetail.midClamp,
    price: structureItem.price,
    mountingStructure: structureItem.name,
    railLength: customDetail.rail,
    walkWayLength: 0,
    beam: customDetail.beam,
    polls: customDetail.polls,
    rails: 0,
    azimuth: 180,
    rowDistance: rowDistance,
    multipleStructure: [],
  };
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: myObject,
    })
  );

  const value = { ...roofDetail, ...myObject };
  generationLosses(value, quantityInfo, dispatch);
};
